// extracted by mini-css-extract-plugin
module.exports = {"filteredItemsWrapper":"filteredItems_filteredItemsWrapper__37tmg","filteredItems":"filteredItems_filteredItems__1D7vM","itemWrapper":"filteredItems_itemWrapper__6vxGK"};